import {createContext} from 'react';

import {AdobeTargetAllMBoxValues, AdobeTargetGlobalMBoxValues} from 'components/app/AdobeTargetProvider/types';
export const TARGET_GLOBAL_MBOX = 'target-global-mbox';

export const initialMBoxValueState: AdobeTargetGlobalMBoxValues = {
  dependenciesStillLoading: false,
  messageBanners: [],
  abTests: []
};

const AdobeTargetContext = createContext<AdobeTargetAllMBoxValues>({
  [TARGET_GLOBAL_MBOX]: initialMBoxValueState,
  abPrefetch: {prefetch: {mboxes: []}}
});

export default AdobeTargetContext;
